<template>
  <ol class="w-full flex flex-wrap list-counter mt-3 mb-5">
    <li v-for="item in items" v-bind:key="item" class="w-full sm:w-auto mr-6 lg:mr-6 md:mr-2 text-xl md:text-base lg:text-xl">
      {{ item }}
    </li>
  </ol>
</template>

<script>
export default {
  name: 'NumberedList',
  props: {
    /**
     * [
     *    'About you',
     *    'Where you live',
     *    'Work and Finances'
     * ]
     */
    items: Array
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .list-counter {
    padding: 0;
    list-style-type: none;
  }

  .list-counter li {
    counter-increment: step-counter;
    display: inline;
  }

  .list-counter li::before {
    content: counter(step-counter);
    margin-right: 5px;
    font-size: 80%;
    background-color: #ffffff;
    color: #000000;
    border: 1px solid #000000;
    padding: 3px 8px;
    border-radius: 100%;
  }

</style>
